<template>
  <div>
    <div ref="googleButton">
      <!--
      <input v-model="googleLogin" type="checkbox" id="googleLogin" name="googleLogin" @change="loginTypeChecked($event)" />
      <label for="googleLogin" class="single-sign-on__button__content">
        <img src="../assets/icons/ic_20_google.svg">Mit Google anmelden
      </label>
      -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'GoogleLogin',
  data() {
    return {
      clientId: '943145692537-elvlet8tq780g58j60gn8vb130m79eq0.apps.googleusercontent.com'
    }
  },
  mounted() {
    // Wait for GIS script to load
    if (window.google && window.google.accounts && window.google.accounts.id) {
      this.initGoogleSignIn()
    } else {
      // Retry after script load
      const interval = setInterval(() => {
        if (window.google && window.google.accounts && window.google.accounts.id) {
          clearInterval(interval)
          this.initGoogleSignIn()
        }
      }, 100)
    }
  },
  methods: {
    initGoogleSignIn() {
      window.google.accounts.id.initialize({
        client_id: this.clientId,
        callback: this.handleCredentialResponse
      })

      window.google.accounts.id.renderButton(
        this.$refs.googleButton,
        {
          theme: "outline",
          size: "large",
          width: "300"
        }
      )
    },
    handleCredentialResponse(response) {
      const token = response.credential
      this.verifyTokenWithBackend(token)
      const user = this.parseJwt(token)
      Vue.$log.debug('GoogleLogin handleCredentialResponse ' + JSON.stringify(user))
      this.$emit('login-success', user)
    },
    async verifyTokenWithBackend(token) {
      try {
        const res = await fetch('https://teamtip.net/auth/google', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: new URLSearchParams({
            credential: token,
            clienttype: 'web',
          })
        });

        const result = await res.text();
        Vue.$log.debug("GoogleLogin Server response:", result)

        if (!res.ok) {
          Vue.$log.debug("GoogleLogin Google login failed: " + result)
          return;
        }

        // You could store session here, or redirect, etc.
      } catch (err) {
        Vue.$log.debug("GoogleLogin Failed to verify token:", err)
      }
    },
    parseJwt(token) {
      try {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        return JSON.parse(decodeURIComponent(escape(window.atob(base64))))
      } catch (e) {
        Vue.$log.debug("GoogleLogin JWT parse error", e)
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .single-sign-on {
    &__divider {
      display: flex;
      align-items: center;
      width: 100%;
      margin: 24px 0;
  
      span {
        font-size: 14px;
        color: rgba($colorGreyDark, .48);
        margin: 0 8px;
      }
  
      div {
        height: 1px;
        width: 100%;
        background: linear-gradient(90deg, $colorGreyDark 0%, rgba($colorGreyDark, 0) 100%);
        opacity: .12;
  
        &:first-of-type {
          background: linear-gradient(90deg, rgba($colorGreyDark, 0) 0%, $colorGreyDark 100%);
        }
      }
    }
  
    &__button {
      display: flex;
      width: 100%;
  
      &:not(:last-child) {
        margin-bottom: 8px;
      }
  
      &__content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background: $colorWhite;
        border-radius: 8px;
        padding: 16px;
        font-size: 17px;
        color: $colorGreyDark;
        box-shadow: 0 0 0 1px rgba($colorGreyDark, .08);
        transition: all .2s ease-in-out;
  
        &:hover {
          box-shadow: 0 0 0 1px rgba($colorGreyDark, .16);
        }
  
        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }
  
      input {
        display: none;
  
        &:checked ~ label {
          box-shadow: 0 0 0 2px $colorPrimary;
        }
      }
    }
  } 
</style>
